import React, { useEffect, useState } from 'react';
import { Drawer, notification, Spin, message } from 'antd';
import { isMobile } from 'react-device-detect';
import api from 'utils/api';

import FileDownload from 'js-file-download';

// eslint-disable-next-line react/prop-types
export const OrderPreview = ({ sales_order_id, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState();

    useEffect(() => {
        setLoading(true);

        async function previewOrder() {
            await api.Orders.previewOrder(sales_order_id)
                .then(data => {
                    console.log(data);
                    if (isMobile) {
                        FileDownload(data, `sales-order-${sales_order_id}.pdf`);
                        onClose();
                        notification.success({ message: 'Document downloaded' });
                    } else {
                        const file = new Blob([data], { type: 'application/pdf' });

                        const fileURL = URL.createObjectURL(file);

                        setLoading(false);
                        setFileURL(fileURL);
                    }
                })
                .catch(error => message.error(error));
        }

        previewOrder();
    }, [sales_order_id]);

    return (
        <Drawer title="Preview" width={'80%'} closable open placement={'left'} onClose={onClose}>
            <Spin spinning={loading}>
                <iframe
                    title={'Sales Order Preview'}
                    src={fileURL}
                    // frameBorder="0"
                    height={window.innerHeight}
                    width="100%"
                />
            </Spin>
        </Drawer>
    );
};
